import React from 'react';
import PropTypes from 'prop-types';
import APButton from '../common/APButton';
import APNumberInput from '../common/APNumberInput';
import APSelect from '../common/APSelect';
import APLabelWithText from '../common/APLabelWithText';
import APCheckbox from '../common/APCheckbox';
import { instrumentPropType } from '../../propTypes/instrumentPropTypes';
import { getBEMClasses } from '../../helpers/cssClassesHelper';
import { styleNames } from '../../propTypes/commonComponent';
import { buyValue, sellValue } from '../../constants/sendOrder/orderEntryFormConstants';
import { getOrderFee } from '../../helpers/orderHelper';
import UserBalanceComponent from '../UserBalance/UserBalanceComponent';
import APInput from '../common/APInput';
import { biggerThanZero } from '../../helpers/formValidations';
import './ReportBlockTradeForm.css';
var bemClasses = getBEMClasses(['report-block-trade-form']);
var slidePaneClasses = getBEMClasses('slide-pane');
var dividerClasses = getBEMClasses('divider');
var ReportBlockTradeForm = function ReportBlockTradeForm(props, context) {
  var position1 = props.position1,
    position2 = props.position2,
    instruments = props.instruments,
    handleSubmit = props.handleSubmit,
    submitting = props.submitting,
    disableTrading = props.disableTrading,
    formObj = props.formObj,
    decimalPlaces = props.decimalPlaces,
    selectedInstrument = props.selectedInstrument,
    invalid = props.invalid,
    positions = props.positions,
    VerificationRequiredComponent = props.VerificationRequiredComponent,
    showLockedIn = props.showLockedIn,
    orderTotal = props.orderTotal,
    orderNet = props.orderNet,
    useNewForm = props.useNewForm;
  var side = formObj.values.side;
  var boughtProductSymbol = side === buyValue ? selectedInstrument.Product1Symbol : selectedInstrument.Product2Symbol;
  var soldProductSymbol = side === buyValue ? selectedInstrument.Product2Symbol : selectedInstrument.Product1Symbol;
  return React.createElement('form', {
    className: slidePaneClasses('body'),
    onSubmit: handleSubmit
  }, React.createElement('div', {
    className: bemClasses('main-section')
  }, React.createElement('div', {
    className: bemClasses('inputs-container')
  }, React.createElement('div', {
    className: bemClasses(null, ['with-padding'])
  }, React.createElement(APSelect, {
    name: 'instrument',
    label: context.t('Instrument') + ':',
    customClass: bemClasses(),
    options: instruments.map(function (instrument) {
      var InstrumentId = instrument.InstrumentId;
      return {
        value: InstrumentId,
        label: instrument.Symbol
      };
    }),
    showTriangles: true
  })), React.createElement('div', {
    className: bemClasses('counterparty')
  }, React.createElement(APInput, {
    name: 'counterparty',
    label: context.t('Counterparty') + ':',
    customClass: bemClasses(),
    validate: [biggerThanZero]
  }), showLockedIn && React.createElement('div', {
    className: bemClasses('checkbox-container')
  }, React.createElement(APCheckbox, {
    name: 'lockedIn',
    type: 'checkbox',
    id: 'locked-in',
    label: context.t('Locked In')
  }))))), React.createElement('div', {
    className: dividerClasses(null, ['dark', 'side-pane-size'])
  }), React.createElement('div', {
    className: bemClasses('inputs-container')
  }, React.createElement('div', {
    className: bemClasses(null, ['with-padding'])
  }, React.createElement(APNumberInput, {
    name: 'quantity',
    placeholder: '0',
    label: context.t(useNewForm ? 'Quantity' : 'Product Bought') + ':',
    decimalPlaces: decimalPlaces[boughtProductSymbol],
    customClass: bemClasses(),
    labelInInput: boughtProductSymbol,
    validate: [biggerThanZero]
  })), React.createElement(APNumberInput, {
    name: 'price',
    placeholder: '0',
    label: context.t(useNewForm ? 'Price' : 'Product Sold') + ':',
    decimalPlaces: decimalPlaces[soldProductSymbol],
    customClass: bemClasses(),
    labelInInput: soldProductSymbol,
    validate: [biggerThanZero]
  })), React.createElement('div', {
    className: dividerClasses(null, ['dark', 'side-pane-size'])
  }), React.createElement('div', {
    className: bemClasses(null, 'with-small-padding')
  }, React.createElement(APLabelWithText, {
    label: context.t('Fees') + ':',
    text: getOrderFee(formObj, positions),
    customClass: bemClasses()
  })), React.createElement('div', {
    className: bemClasses(null, 'with-small-padding')
  }, React.createElement(APLabelWithText, {
    label: context.t('Received') + ':',
    text: orderNet,
    customClass: bemClasses()
  })), React.createElement(APLabelWithText, {
    label: context.t('Order Total') + ':',
    text: orderTotal,
    customClass: bemClasses()
  }), React.createElement('div', {
    className: dividerClasses(null, ['dark', 'side-pane-size'])
  }), React.createElement('div', {
    className: bemClasses('user-balance-container')
  }, React.createElement(UserBalanceComponent, {
    position1: position1,
    position2: position2
  })), React.createElement('div', {
    className: dividerClasses(null, ['dark', 'side-pane-size'])
  }), React.createElement('div', null, React.createElement(APButton, {
    type: 'submit',
    disabled: submitting || invalid || disableTrading,
    customClass: bemClasses(),
    styleName: formObj.values.side === sellValue ? styleNames.subtractive : styleNames.additive
  }, submitting ? context.t('Processing...') : context.t('Submit Report'))), React.createElement('div', {
    className: bemClasses('verification-required')
  }, VerificationRequiredComponent));
};
ReportBlockTradeForm.defaultProps = {
  showLockedIn: true
};
ReportBlockTradeForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  position1: PropTypes.object.isRequired,
  position2: PropTypes.object.isRequired,
  instruments: PropTypes.arrayOf(instrumentPropType).isRequired,
  formObj: PropTypes.object,
  submitting: PropTypes.bool.isRequired,
  VerificationRequiredComponent: PropTypes.element,
  disableTrading: PropTypes.bool.isRequired,
  showLockedIn: PropTypes.bool.isRequired
};
ReportBlockTradeForm.contextTypes = {
  t: PropTypes.func.isRequired
};
export default ReportBlockTradeForm;